module.exports = __webpack_public_path__ + "static/media/set-up.075d8795.png";